var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannerDcOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 16.653c0-.473.392-.857.875-.857h7c.483 0 .875.384.875.857v.49a.866.866 0 01-.875.857h-7a.866.866 0 01-.875-.857v-.49zm10 0c0-.473.392-.857.875-.857h4.5c.483 0 .875.384.875.857v.49a.866.866 0 01-.875.857h-4.5a.866.866 0 01-.875-.857v-.49zm-7.5-4.898c0-.473.392-.857.875-.857h14.5c.483 0 .875.384.875.857v.49a.866.866 0 01-.875.857h-14.5a.866.866 0 01-.875-.857v-.49zM2 6.857C2 6.384 2.392 6 2.875 6h3.25c.483 0 .875.384.875.857v.49a.866.866 0 01-.875.857h-3.25A.866.866 0 012 7.347v-.49zm6.25 0c0-.473.392-.857.875-.857h7c.483 0 .875.384.875.857v.49a.866.866 0 01-.875.857h-7a.866.866 0 01-.875-.857v-.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerDcOutline);
export default __webpack_public_path__ + "ce93127a533f4d75a72187d5398345af.svg";
export { ForwardRef as ReactComponent };